import { useEffect, useRef, useState } from "react";
import { useStoreApi } from "@hmpu/powerups.store";

const ariaLiveMessageSelector = (state) => state.ariaLiveMessage;

function AriaLiveAnnoucer() {

  const { subscribe, getState } = useStoreApi();
  const messageRef = useRef(getState().ariaLiveMessage);
  // @2DO: This name is terrible, fix later
  const [blockOrNot, setBlockOrNot] = useState("block");

  useEffect(() => {
    const unsub = subscribe(
      ariaLiveMessageSelector,
      (curr, prev) => {
        // console.log("AriaLiveAnnoucer :: new message", curr);
        if(curr !== prev && messageRef.current !== null) {
          // @2DO: Append new message inside a node to <aria-live> that has a unique id instead of letting react mutate innerHTML  
          setBlockOrNot("none");
          setTimeout(() => {
            messageRef.current = curr;
            setBlockOrNot("block");
          }, 50)
        }
      }
    );
    return () => {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscribe]);

  // if(messageRef.current) {
  //   console.log('ARIA READER :: ', messageRef.current);
  // }

  return (
    <div
      role="status"
      className="sr-only"
      aria-live="polite"
      aria-atomic="false"
      tabIndex={"-1"}
      style={{
        "visibility": messageRef.current !== null ? "visible" : "hidden",
        "display": blockOrNot
      }}>
      {messageRef.current}
    </div>
  );
}


export default AriaLiveAnnoucer;
